import "slick-carousel"

class Carousel {
  constructor() {
    this.init()
  }

  init () {
    this.cacheDOM()
    this.bindEvents()
    this.initSlider()
  }

  cacheDOM () {
    this.$slider = $( "[id^=slider_block_]" )
    this.$logo_slider = $( "[id^=logo_slider_]" )
  }

  bindEvents () {

  }

  initSlider () {
    this.$slider.slick( {
      dots: false,
      prevArrow: "",
      nextArrow: "",
      fade: true,
    } )

    this.$logo_slider.slick( {
      dots: false,
      autoplay: true,
      autoplaySpeed: 2000,
      prevArrow: "",
      nextArrow: "",
      slidesToShow: 5,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            dots: false,
            prevArrow: "",
            nextArrow: "",
            slidesToShow: 5,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            dots: false,
            prevArrow: "",
            nextArrow: "",
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 768,
          settings: {
            dots: false,
            prevArrow: "",
            nextArrow: "",
            slidesToShow: 2,
          }
        },
      ]
    } )
  }
}

new Carousel()
